import React, { useContext, useEffect, useState } from 'react';

import { Button } from 'semantic-ui-react';

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import {
  StyleRulesFilters,
  LocalStyleRuleSearch,
  StyleRuleSettingsItem,
} from 'components/modules/style-rules/components';

import { PAGE_SIZE } from './StyleRulesSettingsMainPanel.constants';
import { getStyleRuleConfigurationsToDisplay } from './StyleRulesSettingsMainPanel.utils';
import { StyleRulesSettingsTabContext } from '../../SettingsTab.context';

import './StyleRulesSettingsMainPanel.scss';

const propTypes = {};

const defaultProps = {};

export default function StyleRulesSettingsMainPanel() {
  const [amountToShow, setAmountToShow] = useState(PAGE_SIZE);

  const {
    currentStyleRuleConfigurations,
    localSearchQuery,
    onLocalSearchQueryChange,
    highlightedStyleRule,
    onResetFilters,
    onSelectStateFilter,
    onSelectUnitFilter,
    selectedStateFilters,
    selectedUnitFilters,
    getStyleRuleInheritance,
  } = useContext(StyleRulesSettingsTabContext);

  function onShowMore() {
    setAmountToShow((previousAmountToShow) => previousAmountToShow + PAGE_SIZE);
  }

  useEffect(() => {
    setAmountToShow(PAGE_SIZE);
  }, [_get(currentStyleRuleConfigurations, 'length')]);

  return (
    <div className="style-rules-settings-main-panel">
      <div className="top-controls">
        <LocalStyleRuleSearch
          styleRuleConfigurations={currentStyleRuleConfigurations}
          onSearchStyleRule={onLocalSearchQueryChange}
          onSelectStyleRule={onLocalSearchQueryChange}
          searchQuery={localSearchQuery}
        />
        <StyleRulesFilters
          states={selectedStateFilters}
          units={selectedUnitFilters}
          onStatesFilterChange={onSelectStateFilter}
          onUnitsFilterChange={onSelectUnitFilter}
          onReset={onResetFilters}
        />
      </div>

      <div className="rules">
        {_isEmpty(currentStyleRuleConfigurations) && !_isEmpty(localSearchQuery) && (
          <div className="no-results-message">No results</div>
        )}

        {getStyleRuleConfigurationsToDisplay(
          currentStyleRuleConfigurations,
          amountToShow,
          highlightedStyleRule,
        ).map((styleRuleConfiguration) => {
          const { name } = styleRuleConfiguration;

          return (
            <StyleRuleSettingsItem
              key={name}
              styleRuleConfiguration={styleRuleConfiguration}
              highlighted={highlightedStyleRule === name}
              getStyleRuleInheritance={getStyleRuleInheritance}
            />
          );
        })}
      </div>

      <div className="bottom-controls">
        {amountToShow < currentStyleRuleConfigurations.length && (
          <Button
            className="show-more-button action-button"
            onClick={onShowMore}
            content="Show More"
          />
        )}
      </div>
    </div>
  );
}

StyleRulesSettingsMainPanel.propTypes = propTypes;
StyleRulesSettingsMainPanel.defaultProps = defaultProps;
